/**
 * The PO template's branding rules (z8nrz7f7dz), kept pure so the editor's
 * logo dropzone and accent swatches are tested without a DOM.
 */

import { DEFAULT_ACCENT } from './layout'

export const LOGO_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml']
export const LOGO_MAX_BYTES = 1024 * 1024
export const LOGO_HEIGHT_MIN_MM = 8
export const LOGO_HEIGHT_MAX_MM = 40

/** Why a file cannot be the logo, or null when it can. Same rules the server applies. */
export function logoFileProblem(file: Pick<File, 'type' | 'size'>): string | null {
  if (!LOGO_TYPES.includes(file.type)) return 'Use a PNG, JPG or SVG image.'
  if (file.size > LOGO_MAX_BYTES) return 'The logo must be 1 MB or smaller.'
  return null
}

/** A logo height the template accepts: whole millimetres within the slider's range. */
export function clampLogoHeight(mm: number): number {
  if (!Number.isFinite(mm)) return LOGO_HEIGHT_MIN_MM
  return Math.min(LOGO_HEIGHT_MAX_MM, Math.max(LOGO_HEIGHT_MIN_MM, Math.round(mm)))
}

/** One-click accent colours; the first is the built-in default. */
export const ACCENT_PRESETS: { name: string; value: string }[] = [
  { name: 'Navy', value: DEFAULT_ACCENT },
  { name: 'Teal', value: '#0f766e' },
  { name: 'Blue', value: '#1d4ed8' },
  { name: 'Indigo', value: '#4338ca' },
  { name: 'Slate', value: '#334155' },
  { name: 'Emerald', value: '#047857' },
]
